import React, { useEffect, useState, useCallback } from "react";
import DatePicker from "react-datepicker";
import { useQuery } from "@apollo/react-hooks";
import UploadImage from "../Common/upload-image/UploadImage";
import ImageKit from "imagekit-javascript";
import { GET_CATEGORIES } from "../../query/GetCategories";
import { hasuraClient } from "../../apolloClient";
import { IS_EVENT_NAME_EXIST } from "../../query/IsEventNameExist";
import moment from "moment";
import DeletePost from "../Popup/DeletePost";
import SearchAuto from "../LocationAutoComplete/SearchAuto";

const EventInformation = (props) => {
  const { data: allCategories } = useQuery(GET_CATEGORIES, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });

  const { step1Data, setStep1Value } = props;

  const value = {
    name: "",
    location_text: "",
    categories: "",
    description: "",
    date_time: "", // start_date of the event
    end_date: "",
    start_date_time: "",
    end_date_time: "",
    image_path: "",
    image_url: "",
  };
  const [name, setName] = useState(step1Data ? step1Data.name : "");

  const [description, setDescription] = useState(
    step1Data ? step1Data.description : ""
  );
  const [categories, setCategories] = useState(
    step1Data ? step1Data.categories : ""
  );
  const [location, setLocation] = useState(
    step1Data ? step1Data.location_text : ""
  );
  const [date, setDate] = useState(
    step1Data
      ? step1Data.date_time.length > 0
        ? new Date(step1Data.date_time)
        : ""
      : ""
  );
  const [endDate, setEndDate] = useState(
    step1Data
      ? step1Data.end_date.length > 0
        ? new Date(step1Data.end_date)
        : ""
      : ""
  );
  const [start, setStart] = useState(
    step1Data
      ? step1Data.start_date_time.length > 0
        ? new Date(step1Data.start_date_time)
        : ""
      : ""
  );
  const [end, setEnd] = useState(
    step1Data
      ? step1Data.end_date_time.length > 0
        ? new Date(step1Data.end_date_time)
        : ""
      : ""
  );
  const [nameError, setNameError] = useState(false);
  const [existNameError, setExistNameError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [categoriesError, setCategoriesError] = useState(false);
  const [dateError, setDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [startEndDateError, setStartEndDateError] = useState(false);
  const [startError, setStartError] = useState(false);
  const [startFutureError, setStartFutureError] = useState(false);
  const [locationError, setLocationError] = useState(false);
  const [endError, setEndError] = useState(false);

  const profileId = localStorage.getItem("profile_id");

  const [imageLoading, setImageLoading] = useState(false);
  const [uploadedImg, setUploadedImg] = useState(
    step1Data ? step1Data.image_url : ""
  );
  const [imageError, setImageError] = useState("");

  const [imageName, setImageName] = useState(
    step1Data ? step1Data.image_path : ""
  );

  const { refetch } = useQuery(IS_EVENT_NAME_EXIST, {
    client: hasuraClient,
    variables: {
      name: name.trimStart().trimEnd(),
    },
    onCompleted: (res) => {
      if (res?.is_name_exist?.aggregate?.count === 1) {
        if (props?.data?.events_by_pk?.name !== name) {
          setExistNameError(true);
        }
      } else {
        setExistNameError(false);
      }
    },
  });

  useEffect(() => {
    if (props.location_text && props.cordinate) {
      setLocationError(false);
    }
  }, [props.location_text, props.cordinate]);

  useEffect(() => {
    if (uploadedImg) {
      setImageError(false);
    }
  }, [uploadedImg]);

  useEffect(() => {
    if (step1Data) {
      setName(step1Data.name);
      setDescription(step1Data.description);
      setLocation(step1Data.location_text);
      setCategories(step1Data.categories);
      setDate(new Date(step1Data.date_time));
      setEndDate(new Date(step1Data.end_date));
      setStart(new Date(step1Data.start_date_time));
      setEnd(new Date(step1Data.end_date_time));
      setUploadedImg(step1Data.image_url);
      setImageName(step1Data.image_path);
    }
  }, [step1Data]);

  useEffect(() => {
    refetch();
  }, [name]);

  const handleNext = () => {
    let nameErrorVal = false;
    let descriptionErrorVal = false;
    let categoriesErrorVal = false;
    let locationErrorVal = false;
    let dateErrorVal = false;
    let endDateErrorVal = false;
    let startErrorVal = false;
    let endErrorVal = false;
    let imageErrorVal = false;
    let startEndTimeErrorVal = false;
    let startFutureErrorVal = false;
    let startEndDateErrorVal = false;

    if (name === "") {
      nameErrorVal = true;
      setNameError(true);
    } else {
      nameErrorVal = false;
      setNameError(false);
    }

    if (description === "") {
      descriptionErrorVal = true;
      setDescriptionError(true);
    } else {
      descriptionErrorVal = false;
      setDescriptionError(false);
    }

    if (categories === "") {
      categoriesErrorVal = true;
      setCategoriesError(true);
    } else {
      categoriesErrorVal = false;
      setCategoriesError(false);
    }

    if (props.location_text) {
      locationErrorVal = false;
      setLocationError(false);
    } else {
      locationErrorVal = true;
      setLocationError(true);
    }

    if (date === "" || value.date_time === NaN) {
      dateErrorVal = true;
      setDateError(true);
    } else {
      dateErrorVal = false;
      setDateError(false);
    }
    if (endDate === "" || value.end_date === NaN) {
      endDateErrorVal = true;
      setEndDateError(true);
    } else {
      endDateErrorVal = false;
      setEndDateError(false);
    }

    if (moment(date).isAfter(moment(endDate))) {
      startEndDateErrorVal = true;
      setStartEndDateError(true);
    } else {
      startEndDateErrorVal = false;
      setStartEndDateError(false);
    }

    if (start === "") {
      startErrorVal = true;
      setStartError(true);
    } else {
      startErrorVal = false;
      setStartError(false);
    }

    if (moment(date).unix() <= moment().unix()) {
      if (
        moment(
          moment(date).format("YYYY-MM-DD") +
            " " +
            moment(start).format("HH:mm:ss")
        ).unix() <= moment().unix()
      ) {
        startFutureErrorVal = true;
        setStartFutureError(true);
      } else {
        setStartFutureError(false);
        startFutureErrorVal = false;
      }
    }

    if (end === "") {
      endErrorVal = true;
      setEndError(true);
    } else {
      endErrorVal = false;
      setEndError(false);
    }

    if (uploadedImg === "") {
      imageErrorVal = true;
      setImageError(true);
    } else {
      imageErrorVal = false;
      setImageError(false);
    }

    if (
      nameErrorVal === false &&
      descriptionErrorVal === false &&
      locationErrorVal === false &&
      dateErrorVal === false &&
      endDateErrorVal === false &&
      startErrorVal === false &&
      endErrorVal === false &&
      categoriesErrorVal === false &&
      imageErrorVal === false &&
      startEndTimeErrorVal === false &&
      startFutureErrorVal === false &&
      startEndDateErrorVal === false &&
      existNameError === false
    ) {
      setNameError(false);
      setExistNameError(false);
      setDescriptionError(false);
      setLocationError(false);
      setCategoriesError(false);
      setStartError(false);
      setDateError(false);
      setEndDateError(false);
      setEndError(false);
      setStartFutureError(false);

      const values = value;
      values.name = name;
      values.description = description;
      values.categories = categories;
      values.location_text = location;
      values.date_time = date ? new Date(date).toISOString() : "";
      values.end_date = endDate ? new Date(endDate).toISOString() : "";
      values.start_date_time = `${moment(date).format("YYYY-MM-DD")}T${moment(
        start
      ).format("HH:mm:ss")}`;
      values.end_date_time = `${moment(date).format("YYYY-MM-DD")}T${moment(
        end
      ).format("HH:mm:ss")}`;
      values.image_path = `/dev/business_profile/${profileId}/${imageName}`;
      values.image_url = uploadedImg;

      setStep1Value(values);
      if (props?.modalShowD) {
        props.onPressYes(values, false);
      } else {
        props.handleNext(value, 1);
      }
    }
  };

  const imageKit = new ImageKit({
    publicKey: process.env.REACT_APP_PUBLIC_KEY,
    urlEndpoint: process.env.REACT_APP_URL_END_POINT,
    authenticationEndpoint: process.env.REACT_APP_AUTHENTICATION_END_POINT,
  });

  const handleImageUpload = async (imgObj) => {
    setImageLoading(true);

    await imageKit.upload(
      {
        file: imgObj,
        fileName: imgObj.name,
        tags: ["tag1"],
        folder: "/dev/business",
      },
      (err, result) => {
        if (result) {
          setUploadedImg(
            imageKit.url({
              src: result.url,
            })
          );

          setImageName(imgObj.name);

          setImageLoading(false);
        }
      }
    );
  };

  const onImageDrop = useCallback((acceptedFiles) => {
    handleImageUpload(acceptedFiles[0]);
  }, []);

  return (
    <div className="event-list-cover typeofevent-row">
      <DeletePost
        title={"Your changes will be saved. Are you sure you want to exit?"}
        cancelButtonText={"No"}
        deletePostHandler={handleNext}
        show={props?.modalShowD}
        onHide={props?.onPressNo}
      />
      <div className="title">
        <h3>Event information</h3>
        <p>Please enter in your event’s information.</p>
      </div>

      <div className="eventinformation">
        <div className="eventinfo-left">
          <div className="form-group">
            <label>Event Name</label>
            <input
              type="text"
              defaultValue={name ? name : null}
              className="lg-form-control"
              onChange={(event) => {
                setName(event.target.value);
                setNameError(false);
              }}
            />
            <p hidden={!existNameError} className="error-message">
              Event Name exist
            </p>
            <p hidden={!nameError} className="error-message">
              Event Name required
            </p>
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              defaultValue={description ? description : null}
              className="lg-form-control"
              rows="6"
              onChange={(event) => {
                setDescription(event.target.value);
                setDescriptionError(false);
              }}
            ></textarea>
            <p hidden={!descriptionError} className="error-message">
              Event Description required
            </p>
          </div>
          <div className="form-group select">
            <label>Event category</label>
            <select
              className="lg-form-control"
              onBlur={(event) => {
                setCategories(event.target.value);
                setCategoriesError(false);
              }}
              onClick={() => {
                setCategoriesError(false);
              }}
            >
              <option value="">Select</option>
              {allCategories
                ? allCategories.categories.map((category) => {
                    return (
                      <option
                        value={category.id}
                        selected={categories === category.id ? true : false}
                      >
                        {category.name}
                      </option>
                    );
                  })
                : null}
            </select>
            <p hidden={!categoriesError} className="error-message">
              Event Category required
            </p>
          </div>
          <div className="form-group map-input">
            <label>Location</label>
            <SearchAuto
              setCordinate={props.setCordinate}
              setLocation_text={props.setLocation_text}
              location_text={props.location_text}
            />
            {/* <div className="map-icon">
              <input
                defaultValue={step1Data ? step1Data.location_text : null}
                type="text"
                className="lg-form-control"
                onChange={(event) => {
                  setLocation(event.target.value);
                }}
              />
              <img src={map} alt="map-icon" />
            </div> */}
            <p hidden={!locationError} className="error-message">
              Event Location required
            </p>
          </div>
        </div>
        <div className="eventinfo-right">
          <div
            className="event-dates-row"
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <div
              className="form-group event-date-row"
              style={{ marginBottom: "0px" }}
            >
              <label>Start Date</label>
              <DatePicker
                selected={date}
                dateFormat="dd/MM/yyyy"
                dropdownMode="select"
                autoComplete="off"
                onChange={(valueData) => {
                  setDate(valueData);
                  setDateError(false);
                  setStartEndDateError(false);
                }}
                className="react-time-input"
                calendarClassName="react-time-picker"
                popperClassName="react-time-propper"
                minDate={new Date()}
              />
              {/* {startEndDateError ? (
                <p hidden={!startEndDateError} className="error-message">
                  Event Start Date should be before Event End Date
                </p>
              ) : (
                <p hidden={!dateError} className="error-message">
                  Event Start Date required
                </p>
              )} */}
            </div>
            <span
              style={{
                display: "inline-block",
                width: "15px",
                height: "2px",
                background: "#161f3d",
                marginTop: "19px",
                margin: "54px 21px 0px 21px",
              }}
            ></span>
            <div
              className="form-group event-date-row"
              style={{ marginBottom: "0px" }}
            >
              <label>End Date</label>
              <DatePicker
                selected={endDate}
                dateFormat="dd/MM/yyyy"
                dropdownMode="select"
                autoComplete="off"
                onChange={(valueData) => {
                  setEndDate(valueData);
                  setEndDateError(false);
                }}
                className="react-time-input"
                calendarClassName="react-time-picker"
                popperClassName="react-time-propper"
                minDate={date}
              />
              <p hidden={!endDateError} className="error-message">
                Event End Date required
              </p>
            </div>
          </div>
          <div style={{ marginBottom: "26px" }}>
            {startEndDateError ? (
              <p hidden={!startEndDateError} className="error-message">
                Event Start Date should be before Event End Date
              </p>
            ) : (
              <p hidden={!dateError} className="error-message">
                Event Start Date required
              </p>
            )}
            <p hidden={!endDateError} className="error-message">
              Event End Date required
            </p>
          </div>
          <div className="form-group">
            <label>Time</label>
            <div className="time-group">
              <div className="time-left time-input" style={{ marginRight: 21 }}>
                <DatePicker
                  selected={start}
                  dropdownMode="select"
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={30}
                  dateFormat="h:mm aa"
                  autoComplete="off"
                  onChange={(valueData) => {
                    setStart(valueData);
                    setStartError(false);
                    setStartFutureError(false);
                  }}
                  className="react-time-input"
                  calendarClassName="react-time-picker"
                  popperClassName="react-time-propper"
                />
                <p hidden={!startError} className="error-message">
                  Event Start Time required
                </p>
                {startFutureError && (
                  <p hidden={!startFutureError} className="error-message">
                    Select future time
                  </p>
                )}
              </div>
              <span></span>
              <div className="time-right time-input" style={{ marginLeft: 21 }}>
                <DatePicker
                  selected={end}
                  dropdownMode="select"
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={30}
                  dateFormat="h:mm aa"
                  autoComplete="off"
                  onChange={(valueData) => {
                    setEnd(valueData);
                    setEndError(false);
                  }}
                  className="react-time-input"
                  calendarClassName="react-time-picker"
                  popperClassName="react-time-propper"
                />
                <p hidden={!endError} className="error-message">
                  Event End Time required
                </p>
              </div>
            </div>
          </div>
          <div className="form-group add-image-group">
            <label>Add images</label>
            <div className="image-group">
              <UploadImage
                titleNeeded={false}
                onImageDrop={onImageDrop}
                disabled={!!uploadedImg}
                uploadedImg={uploadedImg}
                setUploadedImg={setUploadedImg}
                loading={imageLoading}
              />
            </div>
            <p hidden={!imageError} className="error-message">
              Image required
            </p>
          </div>
        </div>
      </div>

      <div className="event-button-row">
        <button className="next-btn" onClick={handleNext}>
          Next
        </button>
      </div>
    </div>
  );
};

export default EventInformation;
